/**
 * PaymentButton Component
 * Reusable button component for initiating Razorpay payments
 */

import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useRazorpay } from '../hooks/useRazorpay';
import { PaymentData } from '../types/razorpay.types';

interface PaymentButtonProps {
  paymentData: PaymentData;
  variant?: string;
  size?: 'sm' | 'lg';
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const PaymentButton: React.FC<PaymentButtonProps> = ({
  paymentData,
  variant = 'success',
  size = 'lg',
  className = '',
  disabled = false,
  children = 'Pay Now',
}) => {
  const { initiatePayment, isLoading } = useRazorpay();

  const handlePayment = async () => {
    await initiatePayment(paymentData);
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handlePayment}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Processing...
        </>
      ) : (
        children
      )}
    </Button>
  );
};
